import React, { Component } from "react";
import Checkbox from "../../../../components/FormElements/Checkbox";
import Button from "../../../../components/Button";
import { reduxForm, Field } from "redux-form";
import "./index.css";
import OverlayLoader from "../../../../components/OverlayLoader";
import { FormHelperText } from "material-ui/Form";

class PreferencesForm extends Component {
  render() {
    const { handleSubmit, isLoading, submitting, error } = this.props;
    return (
      <form onSubmit={handleSubmit} className="preferences-form">
        {(isLoading || submitting) && <OverlayLoader />}
        <Field
          name="transactionalEmails"
          label="Recieve emails of notifications of your activities of your account & your network activities on Casemasters community.
"
          component={Checkbox}
        />
        <Field
          name="bulkEmails"
          label="Recieve emails of product updates, newsletters, promotional dental content."
          component={Checkbox}
        />
        <FormHelperText error>{error}</FormHelperText>
        <Button value="update" type="submit" />
      </form>
    );
  }
}

export default reduxForm({ form: "preferencesForm" })(PreferencesForm);



// WEBPACK FOOTER //
// ./src/scenes/PreferencesPage/components/PreferencesForm/index.js